import $ from 'jquery';
import {throttle} from 'throttle-debounce';

export default function () {

    const mobileMenuWidth = 992;

    function openMobileMenu() {
        const openMobileMenuButton = $('.header__burger');
        const headerMobileMenu = $('.header');
        if (openMobileMenuButton && headerMobileMenu) {
            $(openMobileMenuButton).click(function () {
                $(this).toggleClass("active");
                $(headerMobileMenu).toggleClass("active");
                $("html").toggleClass("noscroll-mobile")
            })
        }
    }

    function slideToggleMobileMenuItems() {
        if ($(window).width() <= mobileMenuWidth) {
            const menuLvl1 = $('header .header__navigation-left > ul > li.menu-item');
            const menuLvl2 = $('header .header__navigation-left > ul > li.menu-item > ul > li.menu-item');
            addArrow(menuLvl1)
            addArrow(menuLvl2)

            $('.header .header__navigation-left > ul > li.menu-item--expanded').each(function () {
                const span = $(this).find('> span');
                const menu = $(this).find('> ul.menu');

                if (span.length && menu.length) {
                    span.click(function () {
                        menu.toggleClass('menu__display');
                        $('.header .header__navigation-left > ul > li.menu-item').not($(this).parent()).addClass('disable');
                        $('.header .header__navigation-left > ul > li.menu-item:not(.disable)').prepend(createBackButton('lvl1'));
                        $('.header .header__navigation-left > ul > li.menu-item > span').css('display', 'none');
                        handleBackButton('lvl1', menu);
                    });
                }
            });

            menuLvl2.on('click', function () {
                if ($(this).find('> ul').length > 0) {
                    const backButtons = $('header .back-button');
                    menuLvl2.addClass('disable');
                    backButtons.remove();
                    const existingBackButton = $(this).find('.back-button');
                    if (!existingBackButton.length) {
                        $('.header .header__navigation-left > ul > li.menu-item:not(.disable)').prepend(createBackButton('lvl2'));
                    }
                    const spanElement = $(this).find('> span');
                    const ulElement = $(this).find('> ul');
                    if (spanElement.length) {
                        spanElement.addClass('active');
                    }
                    if (ulElement.length) {
                        ulElement.css('display', 'flex');
                    }
                    $(this).removeClass('disable');
                    handleBackButton('lvl2', spanElement, ulElement);
                }
            });
        }
    }

    function handleBackButton(menuLevelClass, additionalEl, ulElement = null) {
        const btnBack = $('.back-button.' + menuLevelClass);
        const menuDisplay = $('header .header__navigation-left > ul > li.menu-item > ul > li.menu-item');

        $(window).on('click', function (event) {
            const target = $(event.target);
            if (menuLevelClass === 'lvl1' && target.hasClass('back-button') && target.hasClass('lvl1')) {
                additionalEl.removeClass('menu__display');
                $('.back-button').remove();
                $('.header .header__navigation-left > ul > li.menu-item').removeClass('disable');
                $('.header .header__navigation-left > ul > li.menu-item > span').css('display', 'flex');
            } else if (menuLevelClass === 'lvl2' && target.hasClass('back-button') && target.hasClass('lvl2')) {
                btnBack.removeClass('lvl2').addClass('lvl1');
                menuDisplay.removeClass('disable');
                additionalEl.removeClass('active');
                ulElement.css('display', 'none');
            }
        });
    }

    function createBackButton(menuLevelClass) {
        const backButton = $('<div>').text('Назад');
        backButton.addClass('back-button').addClass(menuLevelClass);

        return backButton;
    }

    function addArrow(menuLvl) {
        menuLvl.each(function () {
            const subMenu = $(this).find('> ul.menu');
            const spanElement = $(this).find('> span');
            if (subMenu.length && spanElement.length) {
                spanElement.addClass('arrow');
            }
        });
    }

    function menu() {
        const navs = $('nav'),
            liItemsWithSubMenu = $(navs).find('li');
        let hasActiveItem = false,
            timeOutMoseLeave;

        function closeClosestForElement(element, closeSubMenus = false) {
            if (element) {
                if ($(element).closest('.menu__second-section').length > 0) {
                    if (closeSubMenus) {
                        const siblingsLi = $(element).siblings('li');
                        $(siblingsLi).removeClass('hover');
                        $(siblingsLi).find('li:has(ul.menu)').removeClass('hover');
                        $(element).removeClass('hover');
                    }
                } else {
                    $(liItemsWithSubMenu).removeClass('hover');
                    $(element).removeClass('hover');
                }
            } else {
                $(liItemsWithSubMenu).removeClass('hover');
            }
        }

        $(liItemsWithSubMenu).children(':first-child').on('mouseenter', function () {
            const menuItem = $(this).closest('li.menu-item');
            closeClosestForElement(menuItem, true);
            if ($(menuItem).has('ul.menu').length) {
                $(menuItem).addClass('hover');
                $(menuItem).closest('.header').addClass('nav-hovered');
                hasActiveItem = true;
            }
        });

        $(liItemsWithSubMenu).on('mouseleave', function () {
            hasActiveItem = false;
            if (timeOutMoseLeave) {
                clearTimeout(timeOutMoseLeave);
            }
            timeOutMoseLeave = setTimeout(() => {
                if (!hasActiveItem) {
                    closeClosestForElement(this);
                    $(this).closest('.header').removeClass('nav-hovered');
                }
            }, 777);
        });

        $('.menu__second-wrapper').on('mouseleave', function () {
            closeClosestForElement();
            $(this).closest('.header').removeClass('nav-hovered');
        });
    }

    function menuSubstrateHeight() {
        $('.header nav > ul.menu > li').each(function () {
            let submenu = $(this).find('> ul > li');
            let substrate = $(this).find('> .menu-substrate');
            let substrateHeight = substrate.height();

            if (submenu.length) {
                submenu.each(function () {
                    let submenu2 = $(this).find('> ul');
                    if (submenu2.length) {
                        $(this).hover(function () {
                                if (submenu2.height() > substrateHeight) {
                                    substrate.height(submenu2.height());
                                }
                            },
                            function () {
                                substrate.height(substrateHeight);
                            }
                        );
                    }
                });
            }
            ;
        });
    }

    function enableScroll() {
        const header = document.querySelector('header');
        if (window.scrollY > 0) {
            header.classList.add('header_scroll');
        }
    }

    function enableScrollWatcher() {
        let isEnabled = false;
        let header = document.querySelector('.header_fixed');
        if (!header) {
            header = document.querySelector('.header_fixed_black');
        }

        if (header && header.hasAttribute("data-enable-scroll-watcher") && header.hasAttribute("data-hide-under-banner")) {
            let bannerIsScrolled = false;
            let speed = 400;
            const bannerElement = $('#block-bannervverkhunaglavnoy');
            const productBackgroundElement = $('.product-new__background');

            function getMaxHeight() {
                const bannerHeight = bannerElement.length ? bannerElement.height() : 0;
                const productHeight = productBackgroundElement.length ? productBackgroundElement.height() : 0;
                return Math.max(bannerHeight, productHeight);
            }

            let setHeaderFixed = function () {
                $(header).css({"display": "none"});
                $(header).css({"position": ""});
                header.classList.add('header_scroll');
                $(header).fadeIn(speed);
                bannerIsScrolled = true;
            }

            if((window.pageYOffset || document.documentElement.scrollTop) > getMaxHeight()) {
                setHeaderFixed();
            } else {
                $(header).css('position','absolute');
                header.classList.remove('header_scroll');
                bannerIsScrolled = false;
            }

            document.addEventListener('scroll', throttle(100, function () {
                if((window.pageYOffset || document.documentElement.scrollTop) > getMaxHeight()) {
                    if(!bannerIsScrolled) {
                        setHeaderFixed();
                    }
                } else {
                    if(bannerIsScrolled) {
                        $(header).fadeOut(speed, function (){
                            $(header).css('position','absolute');
                            header.classList.remove('header_scroll');
                            $(header).css({"display": ""});
                        });

                        bannerIsScrolled = false;
                    }
                }
            }));

        } else if (header && header.hasAttribute("data-enable-scroll-watcher")) {
            document.addEventListener('scroll', throttle(100, function () {
                const top = window.pageYOffset || document.documentElement.scrollTop;
                if (top > 1) {
                    if (!isEnabled) {
                        isEnabled = true;
                        header.classList.add('header_scroll');
                    }
                } else {
                    if (isEnabled) {
                        isEnabled = false;
                        header.classList.remove('header_scroll');
                    }
                }
            }));
        }
    }

    function setDoubleColumn() {
        const doubleColumns = document.querySelectorAll('.header .double-column')
        doubleColumns && doubleColumns.forEach((doubleColumn) => {
                const menu = doubleColumn.querySelectorAll('.header .header__navigation-left > ul > li.menu-item > ul > li.menu-item');
                сhangeImage(menu)
                menu && menu.forEach((item) => {
                    const columnTwoItem = item && item.querySelector('.menu-item.column-two')
                    if (columnTwoItem) {
                        const parentUl = columnTwoItem.closest('ul');
                        const ColumnUlFirst = document.createElement('ul');
                        ColumnUlFirst.classList.add('wrapper-column-one')
                        const ColumnUlSecond = document.createElement('ul');
                        ColumnUlSecond.classList.add('wrapper-column-two')
                        parentUl.classList.add('menu-double-column')
                        parentUl.querySelectorAll('li') && parentUl.querySelectorAll('li').forEach((parentUlItems) => {
                            if (parentUlItems.classList.contains('column-two')) {
                                ColumnUlSecond.appendChild(parentUlItems)
                            } else {
                                ColumnUlFirst.appendChild(parentUlItems)
                            }
                        })
                        parentUl.appendChild(ColumnUlFirst)
                        parentUl.appendChild(ColumnUlSecond)
                    } else {
                        item.querySelector('li .menu') && item.querySelector('li .menu').classList.add('menu-single-column')
                    }
                })
            }
        )
    }

    function сhangeImage(menu) {
        const firstTwoItems = Array.prototype.slice.call(menu, -2);
        const lastTwoItems = Array.prototype.slice.call(menu, 0, 2);
        const academyLink = document.querySelector('.double-column .academy_link')
        if (!academyLink) {
            return
        }
        const link = academyLink;
        const image = academyLink.querySelector('img');
        const originalLink = link.href;
        const originalImageSrc = image.src;
        firstTwoItems && firstTwoItems.forEach(function (item) {
            item.addEventListener('mouseover', function () {
                link.href = originalLink;
                image.src = originalImageSrc;
            });
        });
        lastTwoItems && lastTwoItems.forEach(function (item) {
            item.addEventListener('mouseover', function () {
                link.href = 'https://nexign.com/ru/nexign-academy';
                image.src = 'https://nexign.com/sites/default/files/all/Academy/academy_menu_200x170_v2.jpg';
            });
        });
    }

    function init() {
        setDoubleColumn()
        openMobileMenu()
        //menu();
        enableScroll();
        enableScrollWatcher();
        slideToggleMobileMenuItems();
        menuSubstrateHeight();
    }

    init();
}
